// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyB7RUJRpH2NrH1e6AtdbGDyPic-alSRIuo",
    authDomain: "barpify-1e702.firebaseapp.com",
    projectId: "barpify-1e702",
    storageBucket: "barpify-1e702.firebasestorage.app",
    messagingSenderId: "429767405472",
    appId: "1:429767405472:web:7996a4c7fb1af675cfbec5",
    measurementId: "G-CVEKX34ZKT"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
